<template>
  <v-container fluid fill-height class="ma-1 pa-0 font-weight-light">
    <v-row no-gutters>
      <v-tooltip top z-index="1000">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-icon v-if="isLastVersion">mdi-flag</v-icon>
            {{ documentVersion }}
          </span>
        </template>
        <span>{{ $t("DocumentVersion") }}</span>
      </v-tooltip>
      <v-spacer />
      <v-tooltip top z-index="1000" v-if="isPdf">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" @click="actionClick('signatures')"
            >mdi-certificate</v-icon
          >
        </template>
        <span>{{ $t("CertifiedSignatures") }}</span>
      </v-tooltip>
      <v-tooltip top z-index="1000" v-if="isDigitallySigned">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">mdi-file-document-edit-outline</v-icon>
        </template>
        <span>{{ $t("DocumentSigned") }}</span>
      </v-tooltip>
      <v-tooltip top z-index="1000">
        <template v-slot:activator="{ on }">
          <p class="pa-0 mx-2 my-0">
            <span v-on="on" class="font-weight-bold mr-1">{{
              fileExtension
            }}</span>
            <span v-on="on">- {{ contentType }}</span>
          </p>
        </template>
        <span>{{ $t("ContentTypeVersion") }}</span>
      </v-tooltip>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: 'DocumentItemFooter',
    props: {
        documentVersion: {
            type: String,
            required: true,
        },
        contentType: {
            type: String,
            required: true,
        },
        fileExtension: {
            type: String,
            required: true,
        },
        isLastVersion: {
            type: Boolean,
            default: false,
        },
        isDigitallySigned: {
            type: Boolean,
            default: false,
        },
        isPdf: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        actionClick(action) {
            this.$emit('on-action-click', action);
        },
    },
};
</script>
